import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import { usersSelector, isSummaryActiveStep } from '../selectors/wizardSelectors';
import { updateStep } from '../actions/wizardActions';
import Users from '../components/Users/Users';

const mapStateToProps = createStructuredSelector({
    editable: isSummaryActiveStep,
    formData: usersSelector
});

const mapDispatchToProps = { updateStep };

export default withTranslation(['common', 'validations', 'wizard'])(
    connect(mapStateToProps, mapDispatchToProps)(Users)
);
